const COLUMNAS_EXCEL = [
    {
        value: 0,
        label: "ESN",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 1,
        label: "MODEL",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
    {
        value: 2,
        label: "IMEI",
        descripcion:
            "",
        verMas: false,
        obligatorio: false,
    },
    {
        value: 3,
        label: "PROVIDER",
        descripcion:
            "",
        verMas: false,
        obligatorio: true,
    },
];

const INDEX_COLUMNAS_EXCEL = {
    ESN: 0,
    MODEL: 1,
    IMEI: 2,
    PROVIDER: 3,
};

const COLUMNAS_EXCEL_STRING = {
    ESN: "ESN",
    MODEL: "MODEL",
    IMEI: "IMEI",
    PROVIDER: "PROVIDER",
};

export {
    COLUMNAS_EXCEL,
    INDEX_COLUMNAS_EXCEL,
    COLUMNAS_EXCEL_STRING,
}